module.exports = __webpack_public_path__ + "img/BRCA3_Plasma.874dd063.png";